// Applies data-playback-rate to <video> elements; browsers reset playbackRate when the source (re)loads, so it is set again on loadedmetadata and play.
const apply = (video) => {
  const rate = parseFloat(video.dataset.playbackRate);
  if (!rate) return;
  video.playbackRate = rate;
  video.defaultPlaybackRate = rate;
};
document.querySelectorAll('video[data-playback-rate]').forEach((video) => {
  apply(video);
  video.addEventListener('loadedmetadata', () => apply(video));
  video.addEventListener('play', () => apply(video));
});
